import "#next/styles/globals.css";
import "#next/styles/google-sign-in.css";
import "ts-error-as-value/lib/globals";
import { AppProps } from "next/app";
import React, { ReactElement, useEffect } from "react";
import { HookProviders } from "#next/hooks/with-react-context";
import { QueryClient, QueryClientProvider } from "react-query";
import { SessionContextProvider, useSession } from "@supabase/auth-helpers-react";
import { createSupabaseBrowserClient } from "#/lib/supabase/supabase-client-ssr";
import { Toaster } from "react-hot-toast";
import { StripeProvider } from "#next/components/stripe/stripe-provider";
import { AxiomWebVitals } from "next-axiom";
import { Logger } from "#/lib/logging";

const queryClient = new QueryClient();
const supabaseClient = createSupabaseBrowserClient();

const ComponentWrapper = ({ Component, pageProps }: AppProps): ReactElement => {
  const [ isInitialized, setIsInitialized ] = React.useState(false);
  const session = useSession();
  useEffect(() => {
    if (Logger.isInitialized || !session?.user.id || isInitialized) {
      return;
    }
    Logger.initialize({ environmentType: "webapp" });
    setIsInitialized(true);
  }, [ session?.user?.id ]);

  return (
    <Component {...pageProps} />
  );
};

const App = (appProps: AppProps): ReactElement => {
  return (
    <main>
      <AxiomWebVitals />
      <QueryClientProvider client={queryClient}>
        <SessionContextProvider
          supabaseClient={supabaseClient}
          initialSession={appProps?.pageProps?.initialSession}
        >
          {/*<AuthProvider supabase={supabaseClient}>*/}
          <HookProviders>
            <StripeProvider>
              <ComponentWrapper {...appProps} />
            </StripeProvider>
          </HookProviders>
          {/*</AuthProvider>*/}
        </SessionContextProvider>
      </QueryClientProvider>
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          duration: 3000
        }}
      />
    </main>
  );
};

export default App;